// Thin fetch wrapper for the Phase 2 backend (/api). Uses httponly cookie
// session (credentials: "include") with the same-origin ingress host.
const BASE = process.env.REACT_APP_BACKEND_URL;
const API = `${BASE}/api`;

async function req(path, { method = "GET", body, headers } = {}) {
  const res = await fetch(`${API}${path}`, {
    method,
    credentials: "include",
    headers: { "Content-Type": "application/json", ...(headers || {}) },
    body: body ? JSON.stringify(body) : undefined,
  });
  let data = {};
  try {
    data = await res.json();
  } catch {
    /* empty body */
  }
  if (!res.ok) {
    const msg = data && data.detail ? data.detail : "Terjadi kesalahan. Coba lagi.";
    throw new Error(typeof msg === "string" ? msg : "Terjadi kesalahan.");
  }
  return data;
}

export const api = {
  register: (email, password, visitorId) =>
    req("/auth/register", { method: "POST", body: { email, password, visitorId } }),
  login: (email, password) => req("/auth/login", { method: "POST", body: { email, password } }),
  logout: () => req("/auth/logout", { method: "POST" }),
  me: () => req("/auth/me"),
  session: () => req("/auth/session"),
  deleteMe: () => req("/auth/me", { method: "DELETE" }),
  forgot: (email) => req("/auth/forgot-password", { method: "POST", body: { email } }),
  reset: (token, password) => req("/auth/reset-password", { method: "POST", body: { token, password } }),
  track: (payload) => req("/events", { method: "POST", body: payload }),
  saveReport: (payload) => req("/reports", { method: "POST", body: payload }),
  myReports: () => req("/reports/me"),
  adminMetrics: (range) => req(`/admin/metrics?range=${encodeURIComponent(range)}`),
  subscriptionMe: () => req("/subscription/me"),
  subscriptionHistory: () => req("/subscription/history"),
  subscriptionCheckout: (plan) => req("/subscription/checkout", { method: "POST", body: { plan } }),
  subscriptionCheckoutAuto: () => req("/subscription/checkout", { method: "POST", body: { autoRenew: true } }),
  paymentCreateTransaction: (plan) => req("/payment/create-transaction", { method: "POST", body: { plan } }),
  subscriptionRecurring: () => req("/subscription/recurring"),
  subscriptionRecurringCancel: () => req("/subscription/recurring/cancel", { method: "POST" }),
  subscriptionVerify: (orderId) => req("/subscription/verify", { method: "POST", body: { orderId } }),
  voucherRedeem: (code) => req("/vouchers/redeem", { method: "POST", body: { code } }),
  communityAccess: () => req("/community/access"),
  communityMessages: (since) => req(`/community/messages${since ? `?since=${encodeURIComponent(since)}` : ""}`),
  communityPost: (text, replyToId) => req("/community/messages", { method: "POST", body: { text, replyToId } }),
  communityReact: (id, emoji) => req(`/community/messages/${id}/react`, { method: "POST", body: { emoji } }),
  communityReport: (messageId, reason) => req("/community/report", { method: "POST", body: { messageId, reason } }),
  communityDelete: (id) => req(`/community/messages/${id}`, { method: "DELETE" }),
  communityPin: (id, days) => req(`/community/messages/${id}/pin`, { method: "POST", body: { days } }),
  communityRestrict: (userId, until) => req("/community/admin/restrict", { method: "POST", body: { userId, until } }),
  communityBan: (userId) => req("/community/admin/ban", { method: "POST", body: { userId } }),
  communityUnban: (userId) => req("/community/admin/unban", { method: "POST", body: { userId } }),
  communityAdminOverview: () => req("/community/admin/overview"),
  communityAdminReports: () => req("/community/admin/reports"),
  adminListUsers: (q) => req(`/admin/users${q ? `?q=${encodeURIComponent(q)}` : ""}`),
  adminSetRole: (userId, role) => req("/admin/users/role", { method: "POST", body: { userId, role } }),
  adminSetTest: (userIds, isTest) => req("/admin/users/test", { method: "POST", body: { userIds, isTest } }),
  adminGrantTestPremium: (userId, days) => req("/admin/users/test-premium", { method: "POST", body: { userId, days } }),
  adminUserSubscription: (uid) => req(`/admin/users/${uid}/subscription`),
  backupGet: () => req("/backup"),
  backupSave: (payload) => req("/backup", { method: "POST", body: payload }),
  backupDelete: () => req("/backup", { method: "DELETE" }),
  adminRevokeTestPremium: (uid) => req(`/admin/users/${uid}/test-premium/revoke`, { method: "POST" }),
  adminRoleAudit: () => req("/admin/role-audit"),
  adminAccessAttempts: () => req("/admin/access-attempts"),
  adminActiveSubscriptions: () => req("/admin/active-subscriptions"),
  adminRevokePremium: (uid) => req(`/admin/users/${uid}/premium/revoke`, { method: "POST" }),
  adminRuntimeInfo: () => req("/admin/runtime-info"),
  adminFindUser: (email) => req("/admin/users/find", { method: "POST", body: { email } }),
  adminMakeResetLink: (email) => req("/admin/users/reset-link", { method: "POST", body: { email } }),
  communityProfile: () => req("/community/profile"),
  communitySetProfile: (displayName) => req("/community/profile", { method: "POST", body: { displayName } }),
  communityNotifications: () => req("/community/notifications"),
  communityNotificationsList: () => req("/community/notifications/list"),
  communityNotificationsSeen: () => req("/community/notifications/seen", { method: "POST" }),
  communityPinned: () => req("/community/pinned"),
};
